import { MarkOptions } from "mark.js";

export const HEIGHT = 33;
export const SIZE = 19;
export const PADDING = (HEIGHT - SIZE) / 2;
export const OFFSET_TOP = 100;
export const DELAY = 300;
export enum ClassName {
  find = "find",
  audio = "audio",
}

export const optionCollection: Record<ClassName, MarkOptions> = {
  [ClassName.find]: { className: ClassName.find, separateWordSearch: false },
  [ClassName.audio]: { className: ClassName.audio },
};
